"use client"
import {
  Dropdown as DSDropdown,
  DropdownItem as DSDropdownItem,
  DropdownItemAvatar as DSDropdownItemAvatar,
  DropdownItemContent as DSDropdownItemContent,
  DropdownItemDescription as DSDropdownItemDescription,
  type DropdownItemProps as DSDropdownItemProps,
  DropdownItemTitle as DSDropdownItemTitle,
  DropdownSeparator as DSDropdownSeparator,
  type ItemRenderLinkComponent,
} from "@opensea/ui-kit"
import { Link } from "../Link"

export type DropdownItemProps = Omit<DSDropdownItemProps, "renderLink">

export const Dropdown = DSDropdown

export function DropdownItem(props: DropdownItemProps) {
  return (
    <DSDropdownItem renderLink={Link as ItemRenderLinkComponent} {...props} />
  )
}

export const DropdownItemAvatar = DSDropdownItemAvatar
export const DropdownItemTitle = DSDropdownItemTitle
export const DropdownItemContent = DSDropdownItemContent
export const DropdownSeparator = DSDropdownSeparator

export const DropdownItemDescription = DSDropdownItemDescription
